module.exports = __webpack_public_path__ + "img/social-step-3.ec1d0693.svg";